import { vendorConstants } from '../constants';

export function vendor(state = {}, action) {
  switch (action.type) {
    case vendorConstants.GET_VENDOR_REQUEST:
      return {
        loading: true
      };
    case vendorConstants.GET_VENDOR_SUCCESS:
      return {
        ...state, vendor: action.data
      };
    case vendorConstants.GET_VENDOR_FAILURE:
      return {
        error: action.error
      };
    case vendorConstants.GET_VENDOR_ALL_REQUEST:
      return {
        loading: true
      };
    case vendorConstants.GET_VENDOR_ALL_SUCCESS:
      return {
        ...state, vendors: action.data
      }
    case vendorConstants.GET_VENDOR_ALL_FAILURE:
      return {
        error: action.error
      };
    case vendorConstants.ADD_VENDOR_REQUEST:
      return {
        loading: true
      };
    case vendorConstants.ADD_VENDOR_SUCCESS:
      return {
        ...state
      };
    case vendorConstants.ADD_VENDOR_FAILURE:
      return {
        error: action.error
      };
    case vendorConstants.ADD_BULK_VENDOR_REQUEST:
      return {
        bulkloading: true
      };
    case vendorConstants.ADD_BULK_VENDOR_SUCCESS:
      return {
        ...state, bulkresults: action.data.data, bulkloading: undefined
      };
    case vendorConstants.ADD_BULK_VENDOR_FAILURE:
      return {
        error: action.error
      };
    case vendorConstants.UPDATE_VENDOR_REQUEST:
      return {
        loading: true
      };
    case vendorConstants.UPDATE_VENDOR_SUCCESS:
      return {
        ...state
      };
    case vendorConstants.UPDATE_VENDOR_FAILURE:
      return {
        error: action.error
      };
    case vendorConstants.DELETE_VENDOR_REQUEST:
      return {
        loading: true
      };
    case vendorConstants.DELETE_VENDOR_SUCCESS:
      return {
        ...state, vendor: undefined
      };
    case vendorConstants.DELETE_VENDOR_FAILURE:
      return {
        error: action.error
      };
    default:
      return state
  }
}
